
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { RangeInput } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
import { ControlledField } from '../utils';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Range Input`}</h1>
<p>{`Similar to the native `}<inlineCode parentName="p">{`input`}</inlineCode>{` of `}<inlineCode parentName="p">{`range`}</inlineCode>{` type, but allows also more than 1 handle i.e. more than 1 value.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { RangeInput } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<ControlledField style={{ maxWidth: 300, width: '100%' }} initialValue={0} component={
  <RangeInput step={1} onChange={x => x} max={100} min={0} value={0} />
} />`} component={RangeInput} mdxType="Playground">
  <ControlledField style={{
        maxWidth: 300,
        width: '100%'
      }} initialValue={0} component={<RangeInput step={1} onChange={x => x} max={100} min={0} value={0} mdxType="RangeInput" />} mdxType="ControlledField" />
</Playground>
<h3>{`Range where min and max values are equal`}</h3>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={1} __code={`<ControlledField style={{ maxWidth: 300, width: '100%' }} initialValue={0} component={
  <RangeInput step={1} onChange={x => x} max={1} min={0} value={0} />
} />`} mdxType="Playground">
  <ControlledField style={{
        maxWidth: 300,
        width: '100%'
      }} initialValue={0} component={<RangeInput step={1} onChange={x => x} max={1} min={0} value={0} mdxType="RangeInput" />} mdxType="ControlledField" />
</Playground>
<h3>{`Range with 2 possible values`}</h3>
<Playground __position={2} __code={`<ControlledField style={{ maxWidth: 300, width: '100%' }} initialValue={[20000, 100000]} component={
  <RangeInput
    step={1000}
    onChange={x => x}
    max={250000}
    min={10000}
    value={[20000, 100000]}
    renderValue={(v) => v.toLocaleString() + ' €'} />
} />`} mdxType="Playground">
  <ControlledField style={{
        maxWidth: 300,
        width: '100%'
      }} initialValue={[20000, 100000]} component={<RangeInput step={1000} onChange={x => x} max={250000} min={10000} value={[20000, 100000]} renderValue={v => v.toLocaleString() + ' €'} mdxType="RangeInput" />} mdxType="ControlledField" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;